import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ColumnListsSlidingPanel from './ColumnListsSlidingPanel';
import {
  resetMappedFieldsInDivision,
  loadMappedFields,
  loadMappedFieldsInDivision,
  addDivisionMapToMapping
} from 'redux/mapping/MappingActions';
import { enableMappedTargetField } from 'redux/targetFields/TargetFieldsActions';

const mapStateToProps = ({mapping, mappingFile}) => ({
  showColumnLists: mapping.showColumnLists,
  activeDivision: mapping.activeDivision,
  mappingInfo: mappingFile.mappingInfo,
  tempMappedFieldsInDivision: mapping.tempMappedFieldsInDivision
});

const mapDispatchToProps = dispatch => ({
  mappingActions: bindActionCreators({
    resetMappedFieldsInDivision,
    loadMappedFields,
    loadMappedFieldsInDivision,
    addDivisionMapToMapping
  }, dispatch),
  targetFieldsActions: bindActionCreators({ enableMappedTargetField }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ColumnListsSlidingPanel);



// WEBPACK FOOTER //
// ./src/shared/components/mapColumns/c/columnListsSlidingPanel/ColumnListsSlidingPanelConnector.js